<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import store from "@/state/store";
import isWeekend from "date-fns/isWeekend";
import VueHtml2pdf from "vue-html2pdf";

export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    if (userType === 2 || userType === 3) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Leave Application",
    meta: [{ name: "description", content: appConfig.description }],
  },
  computed: {
    ...authComputed,
  },
  components: {
    Layout,
    PageHeader,
    VueHtml2pdf,
  },
  mounted() {
    this.fetchLeaveDocuments();
  },
  data() {
    return {
      title: "Leave Application",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Leave Application",
          active: true,
        },
      ],
      application: null,
      log: null,
      supportingDocs: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      holidays: [],
      weekendList: [],
      leaveHolidays: [],
      weekends: 0,
      sortBy: "sn",
      sortDesc: false,
      publicHolidayFields: [
        { key: "lName", label: "Name", sortable: true },
        {
          key: "lDate",
          label: "Date",
          sortable: true,
        },
      ],
      fields: [
        { key: "sn", label: "S/n", sortable: true, thStyle: { width: "5%" } },
        {
          key: "leavedoc_filename",
          label: "File Name",
          sortable: true,
          thStyle: { width: "65%" },
        },
        {
          key: "createdAt",
          label: "Uploaded At",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    fetchLeaveDocuments() {
      const leaveApplicationID = this.$route.params.leaveApplicationID;
      const url = `${this.ROUTES.leaveDoc}/${leaveApplicationID}`;
      this.apiGet(url, "Get Supporting Documents Error").then((res) => {
        const { data } = res;
        data.forEach((doc, index) => {
          this.supportingDocs[index] = { sn: ++index, ...doc };
        });
        //console.log(this.supportingDocs)
        this.totalRows = this.supportingDocs.length;
        this.fetchLeaveApplication();
      });
    },
    getCurrentYearPublicHolidays() {
      this.apiGet(
        `${this.ROUTES.publicHolidays}/year/current`,
        "Error getting public holidays"
      ).then((res) => {
        const { data } = res;
        this.holidays = [];
        data.map((pub) => {
          let val = {
            name: `${pub.ph_name}`,
            date: `${pub.ph_year}-${pub.ph_month}-${pub.ph_day}`,
          };
          this.holidays.push(val);
        });
        let startDate = new Date(this.application.leapp_start_date);
        let endDate = new Date(this.application.leapp_end_date);

        while (startDate <= endDate) {
          if (isWeekend(startDate)) {
            this.weekends++;
          }
          //console.log(startDate);
          this.holidays.map((pubHoliday) => {
            if (
              new Date(pubHoliday.date).toDateString() ===
              startDate.toDateString()
            ) {
              const pubDays = {
                lName: `${pubHoliday.name}`,
                lDate: `${new Date(pubHoliday.date).toDateString()}`,
              };
              this.leaveHolidays.push(pubDays);
            }
          });
          let newDate = startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(newDate);
        }
        //console.log(this.weekends);
      });
    },
    fetchLeaveApplication() {
      const leaveApplicationID = this.$route.params.leaveApplicationID;
      let url = `${this.ROUTES.leaveApplication}/${leaveApplicationID}`;
      this.apiGet(url, "Get Leave Application Error").then(async (res) => {
        const { application, log } = res.data;
        this.application = application;
        this.log = log;
        this.getCurrentYearPublicHolidays();

        url = `${this.ROUTES.leaveDoc}/${this.application.leapp_id}`;
        await this.apiGet(url, "Get Supporting Documents Error").then((res) => {
          const { data } = res;
          data.forEach((doc, index) => {
            this.supportingDocs[index] = { sn: ++index, ...doc };
          });
          this.totalRows = this.supportingDocs.length;
        });
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    selectRow(row) {
      row = row[0];
      window.open(`${row.leavedoc_url}`);
      this.$refs["employee-doc-table"].clearSelected();
    },
    exportFile() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button class="btn btn-danger mr-3" @click="exportFile">
        <i class="fa fa-file-pdf mr-2"></i> Export
      </b-button>

      <b-button
        class="btn btn-success"
        @click="$router.push('/leave-application')"
      >
        <i class="fa fa-arrow-left mr-2"></i>
        Leave Applications
      </b-button>
    </div>
    <scale-loader v-if="apiBusy" />
    <div class="row" v-else>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5 class="font-size-14 mb-0">Leave Details</h5>
              </div>
              <span class="d-inline mb-0">
                <small
                  v-if="application.leapp_status === 0"
                  class="text-warning"
                >
                  Application Pending
                </small>
                <small
                  v-else-if="application.leapp_status === 1"
                  class="text-success"
                >
                  Application Approved
                </small>
                <small
                  v-else-if="application.leapp_status === 2"
                  class="text-danger"
                >
                  Application Declined
                </small>
                <small
                  v-else-if="application.leapp_status === 3"
                  class="text-primary"
                >
                  Leave Active
                </small>
                <small
                  v-else-if="application.leapp_status === 4"
                  class="text-primary"
                >
                  Leave Finished
                </small>
              </span>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> Leave Type </label>
                  <p class="text-muted">
                    {{ application.LeaveType.leave_name }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> Emergency Email Address </label>
                  <p class="text-muted" v-if="application.leapp_alt_email">
                    {{ application.leapp_alt_email }}
                  </p>
                  <p v-else>---</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> Emergency Phone Number </label>
                  <p class="text-muted" v-if="application.leapp_alt_phone">
                    {{ application.leapp_alt_phone }}
                  </p>
                  <p v-else>---</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> Start Date </label>
                  <p class="text-muted">
                    {{ new Date(application.leapp_start_date).toDateString() }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> End Date </label>
                  <p class="text-muted">
                    {{ new Date(application.leapp_end_date).toDateString() }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <label for=""> Leave Length </label>
                  <p class="text-muted">
                    {{ application.leapp_total_days }} days
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-4">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5 class="font-size-14 mb-0">Authorization Log</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-table-simple striped responsive bordered outlined>
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>OFFICER</b-th>
                      <b-th>STATUS</b-th>
                      <b-th>COMMENT</b-th>
                      <b-th>Authorized As</b-th>
                      <b-th>DATE</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(logEntry, index) in log" :key="index">
                      <b-td style="width: 25%">
                        <span>
                          {{ logEntry.officers.emp_first_name }}
                          {{ logEntry.officers.emp_last_name }}
                        </span>
                      </b-td>
                      <b-td style="width: 15%">
                        <span
                          v-if="logEntry.auth_status === 0"
                          class="text-warning"
                        >
                          Pending
                        </span>
                        <span
                          v-else-if="logEntry.auth_status === 1"
                          class="text-success"
                        >
                          Approved
                        </span>
                        <span
                          v-else-if="logEntry.auth_status === 2"
                          class="text-success"
                        >
                          Declined
                        </span>
                      </b-td>
                      <b-td style="width: 40%">
                        <span>
                          {{ logEntry.auth_comment }}
                        </span>
                      </b-td>
                      <b-td style="width: 40%" v-if="logEntry.role">
                        <span>
                          {{ logEntry.role.ar_title }}
                        </span>
                      </b-td>
                      <b-td style="width: 40%" v-else>
                        <span> --- </span>
                      </b-td>
                      <b-td style="width: 20%">
                        <span>
                          {{ new Date(logEntry.updatedAt).toDateString() }}
                          {{
                            new Date(logEntry.updatedAt).toLocaleTimeString()
                          }}
                        </span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-4">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5 class="font-size-14 mb-0">Supporting Documents</h5>
              </div>
            </div>
            <div v-if="supportingDocs.length > 0" class="table-responsive mb-0">
              <b-table
                ref="employee-doc-table"
                bordered
                selectable
                hover
                :items="supportingDocs"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
                select-mode="single"
                @row-selected="selectRow"
              >
                <template #cell(createdAt)="row">
                  <span>
                    {{ new Date(row.value).toDateString() }}
                  </span>
                  <span>
                    {{ new Date(row.value).toLocaleTimeString("en") }}
                  </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="card mt-4">
          <div class="card-body">
            <p>
              <strong class="text-danger">Note:</strong> There're
              <span class="badge-info badge"> {{ weekends }}</span> weekends
              between
              <span class="text-success">{{
                new Date(application.leapp_start_date).toDateString()
              }}</span>
              and
              <span class="text-danger">{{
                new Date(application.leapp_end_date).toDateString()
              }}</span>
            </p>
            <div class="card-header">
              Public Holidays
              <span class="badge badge-danger">{{ leaveHolidays.length }}</span>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                ref="donor-table"
                bordered
                selectable
                hover
                :items="leaveHolidays"
                :fields="publicHolidayFields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                show-empty
                select-mode="single"
              >
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Leave Application"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="text-center">
          <img
            style="width: 15%"
            src="data:image/png;base64,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"
            class="mt-3 mb-3"
          />
          <h4 class="mb-5">Employee Leave Application</h4>
        </div>
        <div class="card-body">
          <div class="p-3 bg-light mb-4 d-flex justify-content-between">
            <div class="d-inline mb-0">
              <h5 class="font-size-14 mb-0">Leave Details</h5>
            </div>
            <span class="d-inline mb-0">
              <small v-if="application.leapp_status === 0" class="text-warning">
                Application Pending
              </small>
              <small
                v-else-if="application.leapp_status === 1"
                class="text-success"
              >
                Application Approved
              </small>
              <small
                v-else-if="application.leapp_status === 2"
                class="text-danger"
              >
                Application Declined
              </small>
              <small
                v-else-if="application.leapp_status === 3"
                class="text-primary"
              >
                Leave Active
              </small>
              <small
                v-else-if="application.leapp_status === 4"
                class="text-primary"
              >
                Leave Finished
              </small>
            </span>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> Leave Type </label>
                <p class="text-muted">
                  {{ application.LeaveType.leave_name }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> Emergency Email Address </label>
                <p class="text-muted" v-if="application.leapp_alt_email">
                  {{ application.leapp_alt_email }}
                </p>
                <p v-else>---</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> Emergency Phone Number </label>
                <p class="text-muted" v-if="application.leapp_alt_phone">
                  {{ application.leapp_alt_phone }}
                </p>
                <p v-else>---</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> Start Date </label>
                <p class="text-muted">
                  {{ new Date(application.leapp_start_date).toDateString() }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> End Date </label>
                <p class="text-muted">
                  {{ new Date(application.leapp_end_date).toDateString() }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for=""> Leave Length </label>
                <p class="text-muted">
                  {{ application.leapp_total_days }} days
                </p>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-4 d-flex justify-content-between">
            <div class="d-inline mb-0">
              <h5 class="font-size-14 mb-0">Authorization Log</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-table-simple striped responsive bordered outlined>
                <b-thead head-variant="light">
                  <b-tr>
                    <b-th>OFFICER</b-th>
                    <b-th>STATUS</b-th>
                    <b-th>COMMENT</b-th>
                    <b-th>Authorized As</b-th>
                    <b-th>DATE</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(logEntry, index) in log" :key="index">
                    <b-td style="width: 25%">
                      <span>
                        {{ logEntry.officers.emp_first_name }}
                        {{ logEntry.officers.emp_last_name }}
                      </span>
                    </b-td>
                    <b-td style="width: 15%">
                      <span
                        v-if="logEntry.auth_status === 0"
                        class="text-warning"
                      >
                        Pending
                      </span>
                      <span
                        v-else-if="logEntry.auth_status === 1"
                        class="text-success"
                      >
                        Approved
                      </span>
                      <span
                        v-else-if="logEntry.auth_status === 2"
                        class="text-success"
                      >
                        Declined
                      </span>
                    </b-td>
                    <b-td style="width: 40%">
                      <span>
                        {{ logEntry.auth_comment }}
                      </span>
                    </b-td>
                    <b-td style="width: 40%" v-if="logEntry.role">
                      <span>
                        {{ logEntry.role.ar_title }}
                      </span>
                    </b-td>
                    <b-td style="width: 40%" v-else>
                      <span> --- </span>
                    </b-td>
                    <b-td style="width: 20%">
                      <span>
                        {{ new Date(logEntry.updatedAt).toDateString() }}
                        {{ new Date(logEntry.updatedAt).toLocaleTimeString() }}
                      </span>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>

          <div class="p-3 bg-light mb-4 d-flex justify-content-between">
            <div class="d-inline mb-0">
              <h5 class="font-size-14 mb-0">Supporting Documents</h5>
            </div>
          </div>
          <div v-if="supportingDocs.length > 0" class="table-responsive mb-0">
            <b-table
              ref="employee-doc-table"
              bordered
              selectable
              hover
              :items="supportingDocs"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              show-empty
              select-mode="single"
              @row-selected="selectRow"
            >
              <template #cell(createdAt)="row">
                <span>
                  {{ new Date(row.value).toDateString() }}
                </span>
                <span>
                  {{ new Date(row.value).toLocaleTimeString("en") }}
                </span>
              </template>
            </b-table>
          </div>

          <p class="">
            <strong class="text-danger">Note:</strong> There're
            <span class="badge-info badge"> {{ weekends }}</span> weekends
            between
            <span class="text-success">{{
              new Date(application.leapp_start_date).toDateString()
            }}</span>
            and
            <span class="text-danger">{{
              new Date(application.leapp_end_date).toDateString()
            }}</span>
          </p>
          <div class="card-header">
            Public Holidays
            <span class="badge badge-danger">{{ leaveHolidays.length }}</span>
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              ref="donor-table"
              bordered
              selectable
              hover
              :items="leaveHolidays"
              :fields="publicHolidayFields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              show-empty
              select-mode="single"
            >
            </b-table>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
  </Layout>
</template>
